import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import strokeColorToFillColor from "../strokeColorToFillColor";

function strokeColorFromAttribute(layer, feature) {
  const colors = layer?.colors;
  if (Array.isArray(colors) && colors.length > 0 && feature) {
    const props = feature.getProperties();
    for (const entry of colors) {
      const key = String(entry?.key ?? "").trim();
      if (!key) continue;
      const raw =
        props[key] ??
        props[key.toLowerCase()] ??
        props[key.toUpperCase()];
      if (raw === undefined || raw === null) continue;
      const valueKey = String(raw).trim();
      if (String(entry?.value ?? "").trim() === valueKey) {
        return entry?.color ?? null;
      }
    }
    return null;
  }

  const cba = layer?.style?.colorByAttribute;
  if (!cba?.attribute || !feature || !Array.isArray(cba.rules)) {
    return null;
  }
  const key = String(cba.attribute).trim();
  if (!key) return null;
  const props = feature.getProperties();
  const raw =
    props[key] ??
    props[key.toLowerCase()] ??
    props[key.toUpperCase()];
  if (raw === undefined || raw === null) return null;
  const valueKey = String(raw).trim();
  const rule = cba.rules.find((r) => String(r?.value ?? "").trim() === valueKey);
  return rule?.color ?? null;
}

// `feature` is optional (legacy callers); when present, per-attribute colors apply.
export const mapStyle = (layer, geometryType, feature) => {
  const style = layer.style;

  let strokeColor = "rgb(77, 80, 79)";
  if (layer?.style?.stroke?.color) {
    strokeColor = layer.style.stroke.color;
  }

  const attributeStroke = feature ? strokeColorFromAttribute(layer, feature) : null;
  if (attributeStroke) {
    strokeColor = attributeStroke;
  }

  const styleOptions = {
    stroke: new Stroke({
      color: strokeColor,
      width: style?.stroke?.width ?? 1,
    }),
  };

  // Apply fill only to polygon geometries
  if (
    geometryType.toLowerCase() === "polygon" ||
    geometryType.toLowerCase() === "multipolygon"
  ) {
    styleOptions.fill = new Fill({
      color: style?.fill?.color ?? strokeColorToFillColor(strokeColor),
    });
  }

  // Apply circle style to point geometries
  if (
    geometryType.toLowerCase() === "point" ||
    geometryType.toLowerCase() === "multipoint"
  ) {
    styleOptions.image = new CircleStyle({
      radius: style?.circle?.radius ? style.circle.radius : 5,
      fill: new Fill({
        color: style?.circle?.fillColor ?? strokeColorToFillColor(strokeColor),
      }),
      stroke: new Stroke({
        color: style?.circle?.strokeColor ?? strokeColor,
        width: style?.circle?.strokeWidth ? style.circle.strokeWidth : 1,
      }),
    });
  }

  return new Style(styleOptions);
};

export default mapStyle;